// export const SOCKET_ADDRESS = 'http://localhost:1738';
export const SOCKET_ADDRESS = 'https://y-backend.com:1738';
export const SOCKET_ADDRESS_WAITING_ROOM = SOCKET_ADDRESS + '/game/waitingroom';
export const SOCKET_ADDRESS_GAME = SOCKET_ADDRESS + '/game/play';

// export const WEB_ADDRESS = 'http://localhost:3000';
export const WEB_ADDRESS = 'https://capturetheflag.y-backend.com';
export const WAITING_ROOM_WEB_ADDRESS = WEB_ADDRESS + '/';
export const GAME_WEB_ADDRESS = WEB_ADDRESS + '/newgame.html';
